import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { createEntityAdapter } from '@ngrx/entity';
import { userActions } from './user.era';
import { jsonCopyObject } from 'globals/helpers/helpers';

export interface Contact {
  is_approved: boolean;
  createdAt: Date;
  createdUid: string;
  createdDisplayName: string;
  uid: string;
  email: string;
  account_name?: string;
  accountId?: string;
  firstName: string;
  lastName: string;
  displayName?: string; // could be app side only
  company?: string;
  role?: string;
  mobile?: string;
  photoURL?: string;
}

export const contactsAdapter = createEntityAdapter<Contact>({ selectId:(c:Contact) => c.email })

export interface FirebaseAccountDocument {
  accountId: string,
  contacts: Contact[]
}

export interface ContactByAccountIdAndEmail { // old contacts.service.contact_accounts
  [accountId:string]: {
    [email:string]: Contact
  }
}

export interface AccountIdListByEmail { // old contacts.service.contact_emails
  [email:string]: string[]
}

export interface ContactsState {
  ids: string[],
  entities: { [cId: string]: Contact },
  contactByAccountIdAndEmail: ContactByAccountIdAndEmail
  accountIdListByEmail: AccountIdListByEmail
}

const initialStateCreator = () => ({
  ids: [],
  entities: {},
  contactByAccountIdAndEmail: {},
  accountIdListByEmail: {}
})

export const contactsActions = createActionGroup({
  source: 'Contacts',
  events: {
    'Load Contacts By Account Id': (accountId: string, contacts:Contact[]) => ({ accountId, contacts }),
  }
})

export const contactsReducer = createReducer(
  { ...initialStateCreator() },
  on(contactsActions.loadContactsByAccountId, (state, { accountId, contacts }) => {
    const { contactByAccountIdAndEmail, accountIdListByEmail } = jsonCopyObject(state)
    if (!contactByAccountIdAndEmail[accountId]) {
      contactByAccountIdAndEmail[accountId] = {}
    }
    contacts = jsonCopyObject(contacts) as Contact[];
    contacts.forEach(contact => {
      const { email, firstName, lastName } = contact
      contact.accountId = accountId
      contactByAccountIdAndEmail[accountId][email] = contact
      if (!accountIdListByEmail[email]) {
        accountIdListByEmail[email] = []
      }
      if (!accountIdListByEmail[email].find(a => a === contact.accountId)) {
        accountIdListByEmail[email].push(contact.accountId)
      }
      contact.displayName = `${firstName || ''}${firstName ? ' ' : ''}${lastName || ''}`
    })

    return contactsAdapter.addMany(contacts, {
      ...state,
      accountIdListByEmail: {...accountIdListByEmail},
      contactByAccountIdAndEmail: {
        ...contactByAccountIdAndEmail,
        [accountId]: {...contactByAccountIdAndEmail[accountId]}
      },
    })
  }),
  on(userActions.logout, (state) => ({ ...initialStateCreator() })) 
)

export const contactsFeature = createFeature({
  name: 'contacts',
  reducer: contactsReducer
});

export const contactsStateSelector = createFeatureSelector<ContactsState>('contacts');



